import request from '@/utils/request'
import { v2Host } from '@/config/host'

// import { cookRequestParams } from '@/modules/common/request'

/**
 * getInteractiveTagList
 * http://playable.dev.com:8067/?doc=system/interactive_tag.go
 */
export function getInteractiveTagList() {
  return request({
    url: `${v2Host}/system/interactive-tag/list`,
    method: 'get',
  })
}

/**
 * 创建标签
 * http://playable.dev.com:8067/?doc=system/interactive_tag.go
 * @param {{pid: number, name: string, is_required: number}} data
 */
export function createInteractiveTag(data) {
  return request({
    url: `${v2Host}/system/interactive-tag/create`,
    method: 'post',
    data: data,
  })
}

/**
 * 更新标签
 * http://playable.dev.com:8067/?doc=system/interactive_tag.go
 * @param {{id: number}}
 * @param {{name: string, is_required: number, is_hidden: number}} data
 */
export function updateInteractiveTag(params, data) {
  return request({
    url: `${v2Host}/system/interactive-tag/update`,
    method: 'post',
    params: params,
    data: data,
  })
}

/**
 * 删除标签
 * http://playable.dev.com:8067/?doc=system/interactive_tag.go
 * @param {{id: number}} params
 */
export function deleteInteractiveTag(params) {
  return request({
    url: `${v2Host}/system/interactive-tag/delete`,
    method: 'post',
    params: params,
  })
}
